import { IMarketYoyGrowthPlanningApi } from '../api/types'
import { IMarketYoyGrowthPlanning } from '../model/types'

export const mapMarketYoyGrowthPlanningToApi = (
  planning: IMarketYoyGrowthPlanning
): IMarketYoyGrowthPlanningApi => ({
  EntryId: planning.entryId,
  UID: planning.uid,
  Created: planning.created,
  CreatedBy: planning.createdBy,
  Modified: planning.modified,
  ModifiedBy: planning.modifiedBy,
  FYear: planning.fYear,
  Status: planning.status,
  IsLocked: planning.isLocked ? 1 : 0,
})
